import { useContext, useEffect } from "react";
import AuthContext from "../../contexts/AuthContext";
import GlobalFedDropdownContext from "../../contexts/GlobalFedDropdownContext";

export const useBOCdropdown = () => {
  const authContext = useContext(AuthContext);
  const globalFedDropdownContext = useContext(GlobalFedDropdownContext);
  const { isWBCI, isFedAdmin, isFedUser, isTeamCoordinator } = authContext.state;
  const { dispatch } = globalFedDropdownContext;

  useEffect(() => {
    dispatch({
      type: "setState",
      showingState: isWBCI || isFedAdmin || isFedUser || isTeamCoordinator,
      dropdownState: isWBCI || isFedAdmin || isTeamCoordinator
    });
  }, [dispatch, isWBCI, isFedAdmin, isFedUser, isTeamCoordinator]);
};
